// extracted by mini-css-extract-plugin
module.exports = {"container":"UserCard_container__30hco","unbanButton":"UserCard_unbanButton__309X2","banButton":"UserCard_banButton__2VPLS","column":"UserCard_column__3XYu1"};